/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import { initializeApollo } from 'gql/client'
import { NextWrapper } from 'data-fetching-wrapper'
import { PaginaDocument, ProgettiDocument, ProgettoDocument } from '@gql/graphql'
import { ProgettiDetailTemplate } from '@components/templates'

const ProgettoDetail = ({ pagina, progetto }) => (
  <ProgettiDetailTemplate pagina={pagina} progetto={progetto} />
)

export const getStaticPaths = NextWrapper.getStaticPaths(async ({ locales }) => {
  let paths = []

  // for (const locale of locales) {
  //   if (locale === 'default') continue

  //   const client = initializeApollo(locale)

  //   const {
  //     data: { progetti },
  //   } = await client.query({
  //     query: ProgettiDocument,
  //   })

  //   progetti?.forEach((x) => paths.push({ params: { slug: x.slug }, locale: locale }))
  // }

  return {
    paths: paths,
    fallback: 'blocking',
  }
}, '/progetti/[slug]')

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { slug }, preview, previewData, locale }) => {
    const client = initializeApollo(locale)
    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { progetto },
    } = await client.query({
      query: ProgettoDocument,
      variables: { slug, preview },
      context: {
        headers,
      },
    })

    if (!progetto) {
      return {
        notFound: true,
      }
    }

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: {
        contentTypeId: progetto.modelPk,
        objectId: progetto.pk,
        chiave: 'progetto-detail',
        preview,
      },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    return {
      props: { progetto, pagina },
      revalidate: 60 * 20,
    }
  },
  '/progetti/[slug]'
)

export default ProgettoDetail
